<template>
  <div class='sub-page'>
    <div class='sub-tab-wrap'>
      <DxTabPanel id="tabpanel" :selected-index.sync="selectedIndex" :data-source='tabs' :focusStateEnabled='true'>
        <template #title="{ data: tab }">
          <div class='sub-title-wrap-tab'>
            <ul>
              <li class='float-left sub-title'>{{tab.title}}</li>
            </ul>
          </div>
        </template>
      </DxTabPanel>
    </div>

    <div class='sub-content'>
      <!-- 여기까지 page header 이하 수정해서 사용-->
      <div class='grid-wrap'>
        <dx-data-grid ref='refScrapCostGrid' :data-source='scrapCostInfoList' :show-borders='true' :showRowLines='false'
          :showColumnLines='true' :hover-state-enabled="true" :allowColumnResizing='true' column-resizing-mode='widget'
          :allow-column-reordering="true" :height='gridHeight' :row-alternation-enabled="true"
          :focused-row-enabled="true" :focused-row-key.sync='focusedRowKey' :auto-navigate-to-focused-row="true"
          key-expr="품번" @row-removed='onRowRemoved' @row-inserting='onRowInserting' @row-inserted='onRowInserted'
          @row-updated='onRowUpdated' @row-updating="onUpdating" @init-new-row='onInitNewRow'
          @editor-preparing='onEditorPreparing' @toolbar-preparing='onToolbarPreparing'>
          <DxSearchPanel :visible="true" placeholder="검색..." />
          <DxExport :enabled="true" file-name="프레스재료비정보" />
          <DxFilterRow :visible="true" apply-filter="auto" />
          <DxEditing :allow-deleting="regMode" :allow-updating="regMode" :allow-adding="regMode" :use-icons="true"
            mode='popup'>
            <DxPopup :show-title="true" :width="700" :height="400" title="프레스재료비 기준정보">
              <DxPosition my="center" at="center" of="window" />
            </DxPopup>
            <DxForm>
              <DxItem :col-count="2" :col-span="2" item-type="group">
                <DxItem data-field="품번"/>
                <DxItem data-field="cvt" />
                <DxItem data-field="자사두께" />
                <DxItem data-field="자사가로" />
                <DxItem data-field="자사세로" />
                <DxItem data-field="자사중량" />
                <DxItem data-field="자사net" />
                <DxItem data-field="자사스크랩중량" />
                <DxItem data-field="모사두께" />
                <DxItem data-field="모사가로" />
                <DxItem data-field="모사세로" />
                <DxItem data-field="모사중량" />
                <DxItem data-field="모사net" />
                <DxItem data-field="모사스크랩중량" />
                <DxItem data-field="재료비불량율" />
              </DxItem>
            </DxForm>
          </DxEditing>
          <DxColumn :allowEditing='false' caption="고객사" data-field="납품처코드" sort-order="asc">
            <DxLookup
             :data-source="고객사Lookup"
              display-expr="거래처명"
              value-expr="거래처코드"
            />
          </DxColumn>
          <DxColumn :allowEditing='false' caption="차종" data-field="차종" width="60" sort-order="asc">
            <DxLookup
             :data-source="차종리스트"
              display-expr="차종"
              value-expr="차종"
            />
          </DxColumn>
          <DxColumn :allowEditing='true' caption="품번" data-field="품번" width="130"
            edit-cell-template="productionGridTemplate"
          >
          </DxColumn>
          <DxColumn :allowEditing='isIdEdit' caption="품명" data-field="품명" width="140"
          >
            <dx-required-rule message="항목을 선택하세요" />
          </DxColumn>
          <DxColumn :allowEditing='true' caption="재질" data-field="재질" :visible='true' width="120">
          </DxColumn>
          <DxColumn :allowEditing='false' caption="품목유형" data-field="품목유형" :visible='true' width="90">
            <DxLookup
             :data-source="itemTypeLookup"
              display-expr="코드명"
              value-expr="코드"
            />
          </DxColumn>
          <DxColumn :allowEditing='true' caption="CVT" data-field="cvt" format='#,##0' dataType="number" width="50">
          </DxColumn>
          <DxColumn caption="코일" alignment="center">
            <DxColumn :allowEditing='false' caption="기준일" data-field="적용일자" format='yyyy-MM-dd' dataType="date">
            </DxColumn>
            <DxColumn :allowEditing='false' caption="구입가" data-field="가격" format='#,##0' dataType="number">
            </DxColumn>
          </DxColumn>
          <DxColumn caption="자사 규격" alignment="center">
            <DxColumn :allowEditing='true' caption="두께" data-field="자사두께" format='#,##0.0' dataType="number">
              <dx-required-rule message="항목을 립력하세요" />
            </DxColumn>
            <DxColumn :allowEditing='true' caption="가로" data-field="자사가로" format='#,##0' dataType="number">
              <dx-required-rule message="항목을 립력하세요" />
            </DxColumn>
            <DxColumn :allowEditing='true' caption="세로" data-field="자사세로" format='#,##0' dataType="number">
              <dx-required-rule message="항목을 립력하세요" />
            </DxColumn>
            <DxColumn :allowEditing='true' caption="RM중량" data-field="자사중량" format='#,##0.00000' dataType="number">
              <dx-required-rule message="항목을 립력하세요" />
            </DxColumn>
            <DxColumn :allowEditing='true' caption="NET중량" data-field="자사net" format='#,##0.00000' dataType="number">
              <dx-required-rule message="항목을 립력하세요" />
            </DxColumn>
            <DxColumn :allowEditing='true' caption="스크랩중량" data-field="자사스크랩중량" format='#,##0.00000' dataType="number">
              <dx-required-rule message="항목을 립력하세요" />
            </DxColumn>
          </DxColumn>
          <DxColumn caption="고객사 규격" alignment="center">
            <DxColumn :allowEditing='true' caption="고객사두께" data-field="모사두께" format='#,##0.0' dataType="number">
            </DxColumn>
            <DxColumn :allowEditing='true' caption="고객사가로" data-field="모사가로" format='#,##0' dataType="number">
            </DxColumn>
            <DxColumn :allowEditing='true' caption="고객사세로" data-field="모사세로" format='#,##0' dataType="number">
            </DxColumn>
            <DxColumn :allowEditing='true' caption="고객사RM중량" data-field="모사중량" format='#,##0.00000' dataType="number">
            </DxColumn>
            <DxColumn :allowEditing='true' caption="고객사NET중량" data-field="모사net" format='#,##0.00000' dataType="number">
            </DxColumn>
            <DxColumn :allowEditing='true' caption="고객사스크랩중량" data-field="모사스크랩중량" format='#,##0.00000' dataType="number">
            </DxColumn>
          </DxColumn>
          <DxColumn caption="재료비(스크랩반영)" alignment="center">
            <DxColumn :allowEditing='true' caption="불량율" data-field="재료비불량율"
              format='#,##0.0000' dataType="number">
            </DxColumn>
            <DxColumn :allowEditing='false' caption="자사" data-field="자체재료비" :calculate-cell-value="calcScrapCostSelf"
              format='#,##0.00' dataType="number">
            </DxColumn>
            <DxColumn :allowEditing='false' caption="고객사" data-field="모사재료비" :calculate-cell-value="calcScrapCostMother"
              format='#,##0.00' dataType="number">
            </DxColumn>
            <DxColumn :allowEditing='false' caption="차이" data-field="차이" :calculate-cell-value="calcDiff"
              format='#,##0.00' dataType="number">
            </DxColumn>
          </DxColumn>
          <DxSummary>
            <DxTotalItem value-format='#,##0' show-in-column="품번" display-format="{0} (건)" />
          </DxSummary>
          <dx-paging :enabled="false" />
          <dx-scrolling mode="virtual" showScrollbar='always' :useNative='false' />
          <dx-sorting mode="multiple" />
          <template #productionGridTemplate="{ data: cellInfo }">
            <ProductionGridComponent :value="cellInfo.value" :on-value-changed="cellInfo.setValue"
              @selected-pcode='setProductionCode' :productionInfo='productionList' :isEdit='isIdEdit' />
          </template>
          <template #scrap-price-date>
            <div class="toolbar-label" style='font-size:1.2rem;margin-left:10px;'>
              <b> 스크랩단가 적용일: {{scrapDate}} / 가격: {{scrapPrice}}원</b>
            </div>
          </template>
        </dx-data-grid>
        <DxPopupGen :visible.sync="popupCoilPrice" :drag-enabled="true" :close-on-outside-click="false"
          :show-title="true" :width="660" :height="580" title="원자재(코일)가격 조회">
          <dx-data-grid :data-source='coilPriceInfoList' :show-borders='true' :showRowLines='false'
            :showColumnLines='true' :hover-state-enabled="true" :allowColumnResizing='true'
            column-resizing-mode='widget' :allow-column-reordering="true" height='500' :row-alternation-enabled="true"
            :focused-row-enabled="true" :auto-navigate-to-focused-row="false" key-expr="seqId"
            @toolbar-preparing='onToolbarPreparingCoilPrice'
          >
            <DxExport :enabled="true" file-name="원자재(코일)가 현황" />
            <DxFilterRow :visible="true" apply-filter="auto" />
            <DxColumn caption="적용일자" data-field="적용일자" format='yyyy-MM-dd' dataType="date">
            </DxColumn>
            <DxColumn sort-order="desc" caption="재질" data-field="재질" :visible='true' width="160">
            </DxColumn>
            <DxColumn caption="가격" data-field="가격" format='#,##0' dataType="number">
            </DxColumn>
            <DxColumn caption="비고" data-field="비고" :visible='true' width="160">
            </DxColumn>
            <dx-paging :enabled="false" />
            <dx-scrolling mode="virtual" showScrollbar='always' :useNative='false' />
            <dx-sorting mode="multiple" />
          </dx-data-grid>
        </DxPopupGen>
        <DxPopupGen
          :visible.sync="popupCoilPriceFromExcel" :drag-enabled="true" :close-on-outside-click="false"
          :show-title="true" :width="600" :height="600" title="원자재(코일) 변동가 일괄등록">
          <div class="coil-price-wrap">
            <dx-data-grid :data-source='coilBatchPriceInfoList' :show-borders='true' :showRowLines='false'
              :showColumnLines='true' :hover-state-enabled="true" :allowColumnResizing='true'
              column-resizing-mode='widget' :allow-column-reordering="true" height='520' :row-alternation-enabled="true"
              :focused-row-enabled="false" :auto-navigate-to-focused-row="false"
              @toolbar-preparing='onToolbarPreparingBatch'>
              <DxExport :enabled="true" file-name="원자재(코일)가 변동현황" />
              <DxFilterRow :visible="true" apply-filter="auto" />
              <DxColumn caption="적용일자" data-field="적용일자" format='yyyy-MM-dd' dataType="date">
              </DxColumn>
              <DxColumn sort-order="desc" caption="재질" data-field="재질" :visible='true' width="160">
              </DxColumn>
              <DxColumn :allowEditing="true" caption="메세지" data-field="메세지" :visible='true' width="160">
              </DxColumn>
              <DxColumn :allowEditing='true' caption="가격" data-field="가격" format='#,##0' dataType="number">
              </DxColumn>
              <dx-paging :enabled="false" />
              <dx-scrolling mode="virtual" showScrollbar='always' :useNative='false' />
              <dx-sorting mode="multiple" />
            </dx-data-grid>
          </div>
          <!-- <div style="width:238px;margin:30px auto 0 auto;">
            <DxButton
              :width="238"
              text="H-KMC 파일선택"
              type="default"
              styling-mode="contained"
              @click="onClickFileSelect($event)"
            />
          </div> -->
        </DxPopupGen>
      </div>
      <input id="batch-detail-input" type="file" @change="onReadCoilPrice($event)" accept=".xlsx"
        style='display: none;'>
      <loading :active.sync="isLoading" color='rgb(2, 110, 156)' loader='bars'></loading>
    </div>
    <!--sub-conten end-->

  </div>
</template>

<script>
import Loading from 'vue-loading-overlay'
import DxTabPanel from 'devextreme-vue/tab-panel'
import ConstDef from '../../share/ConstDef'
import AppLib from '../../share/AppLib'
import DxDataGrid, { DxScrolling, DxFilterRow, DxExport, DxTotalItem, DxForm, DxPosition, DxLookup,
  DxSummary, DxColumn, DxPaging, DxSorting, DxEditing, DxSearchPanel, DxPopup } from 'devextreme-vue/data-grid'
import { DxRequiredRule } from 'devextreme-vue/validator'
import { DxItem } from 'devextreme-vue/form'
import ProductionGridComponent from '../../share/component/ProductionGridComponent'
import { DxPopup as DxPopupGen } from 'devextreme-vue/popup'
import ExcelJS from 'exceljs'

export default {
  name: 'PressScrapCostComponent',
  data: function () {
    return {
      isLoading: false,
      userInfo: null,
      gridHeight: null,
      selectedIndex: 0,
      tabs: [
        {
          title: '프레스재료비정보'
        }
      ],
      scrapCostInfoList: null,
      차종리스트: [],
      isIdEdit: true,
      scrapDate: null,
      scrapPrice: null,
      today: null,
      focusedRowKey: null,
      rawMeterialTypeLookup: null,
      itemTypeLookup: null,
      productionList: null,
      selectedProductionCode: null,
      고객사Lookup: null,
      // popup coil price
      coilBasePriceDate: AppLib.getToday(),
      coilPriceInfoList: null,
      popupCoilPrice: false,
      popupCoilPriceFromExcel: false,
      coilPriceDate: null,
      isEditDate: false,
      // popup batch price coil
      coilBatchPriceInfoList: null,
      lastCoilPriceRegDate: null,
      coilRegDateBox: null
    }
  },
  props: {
    regMode: {
      type: Boolean,
      default: true
    }
  },
  components: {
    Loading,
    DxTabPanel,
    DxScrolling,
    DxFilterRow,
    DxExport,
    DxTotalItem,
    DxSummary,
    DxColumn,
    DxPaging,
    DxSorting,
    DxEditing,
    DxSearchPanel,
    DxDataGrid,
    DxRequiredRule,
    DxPopup,
    DxItem,
    DxForm,
    DxPosition,
    ProductionGridComponent,
    DxPopupGen,
    DxLookup
  },
  created () {
    document.title = ConstDef.WEB_TAB_TITLE
    this.userInfo = this.$store.getters.getUserInfo
    if (this.userInfo === null) {
      this.$router.push('/')
      return
    }
    this.today = AppLib.getToday()
    this.itemTypeLookup = this.$store.getters.getBaseDataByType(ConstDef.품목유형)
    this.rawMeterialTypeLookup = this.$store.getters.getRawMeterial
    this.고객사Lookup = this.$store.getters.getCustomerInfo
    this.refreshProduction()
    this.refreshScrapPrice()
  },
  mounted () {
    this.gridHeight = (screen.height - 250) * 0.95
  },
  updated () {
  },
  beforeDestroy: function () {

  },
  methods: {
    calcScrapCostSelf (row) {
      return row.재료비
    },
    calcScrapCostMother (row) {
      if (row.모사중량 !== null) {
        return (row.모사중량 * row.가격 * row.재료비불량율) - (row.모사스크랩중량 * this.scrapPrice * ConstDef.스크랩_회수율)
      } else {
        return row.재료비
      }
    },
    calcDiff (row) {
      let mother = 0
      if (row.모사중량 !== null) {
        mother = (row.모사중량 * row.가격 * row.재료비불량율) - (row.모사스크랩중량 * this.scrapPrice * ConstDef.스크랩_회수율)
      } else {
        mother = row.재료비
      }
      return mother - row.재료비
    },
    onEditorPreparing (e) {
      if (e.dataField === 'cvt' && e.row !== undefined) {
        if (e.row.isNewRow === true) {
          this.isIdEdit = true
        } else {
          this.isIdEdit = false
        }
        // console.log(this.isIdEdit)
      }
    },
    onInitNewRow (row) {
      row.data.사용유무 = true
      row.data.삭제유무 = false
      row.data.품번 = this.$route.query.품번
      row.data.품명 = this.$route.query.품명
      row.data.재료비불량율 = 1.0
      this.selectedProductionCode = this.$route.query.품번
    },
    onRowInserting (row) {
      // row.data.품번 = this.selectedProductionCode
      console.log('onRowInserting')
      console.log(row)
      if (this.$_.findIndex(this.scrapCostInfoList, { 품번: row.data.품번 }) >= 0) {
        this.$snotify.error('품번이 중복되었습니다.')
        row.cancel = true
      }
    },
    onRowInserted (row) {
      row.data.updatetime = row.data.createtime = AppLib.getNow()
      row.data.updateid = row.data.createid = this.userInfo.userId
      // row.data.자사중량 = row.data.자사두께 * row.data.자사가로 * row.data.자사세로 * ConstDef.스크랩_비중 / 1000000 / row.data.cvt
      // row.data.자사스크랩중량 = row.data.자사중량 - row.data.자사net
      row.data.재질 = this.$_.findWhere(this.productionList, { 품번: this.selectedProductionCode }).재질
      const where = this.$_.findWhere(this.rawMeterialTypeLookup, { 재질: row.data.재질 })
      row.data.가격 = where.가격
      row.data.적용일자 = where.적용일자
      console.log(row.data)
      if (row.data.모사두께 === undefined || row.data.모사가로 === undefined || row.data.모사세로 === undefined || row.data.모사net === undefined) {
        row.data.모사두께 = row.data.자사두께
        row.data.모사가로 = row.data.자사가로
        row.data.모사세로 = row.data.자사세로
        row.data.모사net = row.data.자사net
        row.data.모사중량 = row.data.자사중량
        row.data.모사스크랩중량 = row.data.자사스크랩중량
      }
      // row.data.품번 = this.selectedProductionCode
      console.log(row.data)
      this.$_sp.runInsertSqlProc('프레스재료비정보', ['품명', '가격', '적용일자', '재질', '차종', '품목유형', '재료비불량율', '거래처코드'], [row.data])
        .then((data) => {
          this.$snotify.info('저장 되었습니다.')
        })
        .catch(error => {
          this.isLoading = false
          if (error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            this.$snotify.error(`에러코드 : ${error.response.status}`)
          }
        })
      this.updateBadRate({ 품번: row.data.품번, 재료비불량율: row.data.재료비불량율 })
    },
    updateBadRate (param) {
      this.$_sp.runUpdateSqlProc('품목정보', ['품번'], null, [param])
        .then(data => {
          // todo 외주구입가 업데이트 spUpdatePurchasePressLastDate
          this.$_sp.runUpdateProc('spRefreshPressPurchasePriceGtToday', [param])
            .then((data) => {
            })
        })
    },
    onRowRemoved (row) {
      this.$_sp.runDeleteSqlProc('프레스재료비정보', [{ 품번: row.data.품번 }])
        .then((data) => {
          this.$snotify.info('삭제 되었습니다.')
          this.refreshPressPurchasePrice(row.data.품번)
        })
    },
    onUpdating (row) {
    },
    onRowUpdated (row) {
      console.log(row.data)
      row.data.updatetime = AppLib.getNow()
      row.data.updateid = this.userInfo.userId
      // row.data.자사중량 = row.data.자사두께 * row.data.자사가로 * row.data.자사세로 * ConstDef.스크랩_비중 / 1000000 / row.data.cvt
      // row.data.자사스크랩중량 = row.data.자사중량 - row.data.자사net
      // if (row.data.모사두께 === null || row.data.모사가로 === null || row.data.모사세로 === null || row.data.모사net === null) {
      //   row.data.모사두께 = null
      //   row.data.모사가로 = null
      //   row.data.모사세로 = null
      //   row.data.모사net = null
      //   row.data.모사중량 = null
      //   row.data.모사스크랩중량 = null
      // } else {
      //   row.data.모사중량 = row.data.모사두께 * row.data.모사가로 * row.data.모사세로 * ConstDef.스크랩_비중 / 1000000 / row.data.cvt
      //   row.data.모사스크랩중량 = row.data.모사중량 - row.data.모사net
      // }
      this.$_sp.runUpdateSqlProc('프레스재료비정보', ['품번'], ['품명', '가격', '적용일자', '재질', '재료비', '차종', '품목유형', '재료비불량율', '거래처코드', '납품처코드'], [row.data])
        .then((data) => {
          this.$snotify.info('저장 되었습니다.')
          this.refreshPressPurchasePrice(row.data.품번)
          this.refreshScrapCostType()
        })
        .catch(error => {
          this.isLoading = false
          if (error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            this.$snotify.error(`에러코드 : ${error.response.status}`)
          }
        })
      this.updateBadRate({ 품번: row.data.품번, 재료비불량율: row.data.재료비불량율 })
    },
    onToolbarPreparing (e) {
      if (this.regMode === false) return

      e.toolbarOptions.items.unshift(
        {
          location: 'before',
          template: function () {
            return `<div class="toolbar-label" style='margin-left:4px;'><b>기준일:</b></div>`
          }
        },
        {
          location: 'before',
          widget: 'dxDateBox',
          options: {
            width: 94,
            value: this.today,
            type: 'date',
            displayFormat: 'yyyy-MM-dd',
            onValueChanged: (args) => {
              console.log(args)
              this.today = args.value
              this.refreshScrapPrice()
            }
          }
        },
        {
          location: 'before',
          template: 'scrap-price-date'
        },
        // {
        //   location: 'after',
        //   widget: 'dxButton',
        //   options: {
        //     hint: '스크랩 변동가 등록',
        //     icon: 'add',
        //     text: '스크랩가 등록',
        //     type: 'default',
        //     focusStateEnabled: true,
        //     onClick: (args) => {
        //       this.refreshScrapPriceHistory()
        //     }
        //   }
        // },
        // {
        //   location: 'after',
        //   widget: 'dxButton',
        //   options: {
        //     hint: '원자재(코일) 변동 가격 등록',
        //     icon: 'add',
        //     text: '원자재(코일)가 등록',
        //     type: 'success',
        //     focusStateEnabled: true,
        //     onClick: (args) => {
        //       this.refreshCoilPriceHistory()
        //     }
        //   }
        // },
        {
          location: 'after',
          widget: 'dxButton',
          options: {
            hint: '원자재(코일)가격 조회',
            icon: 'search',
            text: '원자재(코일)가격 조회',
            type: 'default',
            focusStateEnabled: true,
            onClick: (args) => {
              this.refreshCoilPriceHistory()
            }
          }
        },
        {
          location: 'after',
          widget: 'dxButton',
          options: {
            hint: '원자재(코일) 변동 가격 일괄등록',
            icon: 'xlsfile',
            text: '원자재(코일)가 일괄등록',
            type: 'danger',
            focusStateEnabled: true,
            onClick: (args) => {
              this.regColiPriceFromExcel()
            }
          }
        },
        {
          location: 'after',
          widget: 'dxButton',
          options: {
            hint: '외주품 구입가 전월 재계산',
            icon: 'refresh',
            text: '구입가 재산출',
            type: 'success',
            visible: false,
            focusStateEnabled: true,
            onClick: (args) => {
              this.$snotify.confirm('모든 외주품 월별 구입가를 현재 규격으로 재산출 합니다. 반드시 필요한 경우에만 실행 하여주세요.', '', {
                timeout: 0,
                showProgressBar: true,
                closeOnClick: false,
                pauseOnHover: true,
                buttons: [
                  { text: '재산출',
                    action: (toast) => {
                      this.isLoading = true
                      this.$_sp.runNoEncodeFindProc('spReBuildAllPressPurchasePrice', null)
                        .then((data) => {
                          this.isLoading = false
                          this.$snotify.info('완료되었습니다.')
                        })
                        .catch(error => {
                          this.isLoading = false
                          if (error.response.status === ConstDef.GENERRAL_ERROR) {
                            this.$snotify.error(error.response.data.message)
                          } else {
                            this.$snotify.error(`에러코드 : ${error.response.status}`)
                          }
                        })
                      this.$snotify.remove(toast.id)
                    }
                  },
                  { text: '취소',
                    action: (toast) => { this.$snotify.remove(toast.id) }
                  }
                ]
              })
            }
          }
        }
      )
    },
    refreshScrapCostType () {
      this.isLoading = true
      this.$_sp.runNoEncodeFindProc('spFindAllScrapCostByDate', { date: this.today })
        .then((data) => {
          this.scrapCostInfoList = this.$_sp.MakeModel(data)
          this.차종리스트 = []
          const gByCarType = this.$_.groupBy(this.scrapCostInfoList, function (carList) { return carList.차종 })
          let array = Object.keys(gByCarType)
          for (var i in array) {
            this.차종리스트.push({ 차종: array[i] })
          }
          this.isLoading = false

          if (this.$route.query.품번 !== undefined) {
            if (this.$_.findIndex(this.scrapCostInfoList, { 품번: this.$route.query.품번 }) < 0) {
              setTimeout(() => {
                this.$refs.refScrapCostGrid.instance.addRow()
              }, 100)
            }
          }
        })
        .catch(error => {
          this.isLoading = false
          if (error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            this.$snotify.error(`에러코드 : ${error.response.status}`)
          }
        })
    },
    refreshScrapPrice () {
      this.$_sp.runNoEncodeFindProc('spFindAllScrapPriceByDate', { date: this.today })
        .then((data) => {
          let result = this.$_sp.MakeModel(data)
          if (result.length === 0) {
            this.$snotify.error('해당일 기준 등록된 스크랩 단가가 없습니다.')
            this.scrapCostInfoList = null
          } else {
            this.scrapPrice = result[0].가격
            this.scrapDate = AppLib.formatDateFromTimeStamp(result[0].적용일자)
            this.refreshScrapCostType()
          }
        })
    },
    refreshProduction () {
      this.$_sp.runNoEncodeFindProc('spFindAllProductByPress', {})
        .then((data) => {
          this.productionList = this.$_sp.MakeModel(data)
          console.log(this.productionList)
          if (this.$route.query.품번 !== undefined) {
            setTimeout(() => {
              this.focusedRowKey = this.$route.query.품번
            }, 900)
          }
        })
        .catch(error => {
          this.isLoading = false
          if (error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            this.$snotify.error(`에러코드 : ${error.response.status}`)
          }
        })
    },
    // emit compnay search
    setProductionCode (code) {
      this.selectedProductionCode = code
    },
    refreshScrapPriceHistory () {
      this.$_sp.runNoEncodeFindSqlProc('스크랩코일가격', { 재질: 'SCRAP' })
        .then((data) => {
          this.scrapPriceInfoList = this.$_sp.MakeModel(data)
          console.log(this.scrapPriceInfoList)
          this.popupScrapPrice = true
        })
        .catch(error => {
          this.isLoading = false
          if (error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            this.$snotify.error(`에러코드 : ${error.response.status}`)
          }
        })
    },
    // popup coil price
    onToolbarPreparingCoilPrice (e) {
      e.toolbarOptions.items.unshift(
        {
          location: 'before',
          template: function () {
            return `<div class="toolbar-label" style='margin-left:4px;'><b>기준일:</b></div>`
          }
        },
        {
          location: 'before',
          widget: 'dxDateBox',
          options: {
            width: 94,
            value: this.coilBasePriceDate,
            type: 'date',
            displayFormat: 'yyyy-MM-dd',
            onValueChanged: (args) => {
              this.coilBasePriceDate = args.value
              this.refreshCoilPriceHistory()
            }
          }
        }
      )
    },
    refreshCoilPriceHistory () {
      this.$_sp.runNoEncodeFindProc('spFindAllCoilPriceHistoryByDate', { 기준일: this.coilBasePriceDate })
        .then((data) => {
          this.coilPriceInfoList = this.$_sp.MakeModel(data)
          console.log(this.coilPriceInfoList)
          this.popupCoilPrice = true
        })
    },
    regColiPriceFromExcel () {
      this.coilBatchPriceInfoList = []
      this.$_sp.runNoEncodeFindProc('spFindAllLastDateCoilPrice', null)
        .then(data => {
          const temp = this.$_sp.MakeModel(data)
          if (temp.length > 0) {
            this.lastCoilPriceRegDate = this.$_sp.MakeModel(data)[0].적용일자
          } else {
            this.lastCoilPriceRegDate = null
          }
          this.checkRegDate(`${AppLib.calcMonthFromToday(-1).substring(0, 7)}-01`)
          this.popupCoilPriceFromExcel = true
        })
    },
    onClickFileSelect () {
      if (this.coilPriceDate === null) {
        this.$snotify.info('적용일자를 선택하여 주세요')
        return
      }
      this.$Q('#batch-detail-input').click()
    },
    confirmRegColiPrice () {
      this.$snotify.confirm(`${this.coilPriceDate} 기준 코일 가격을 등록 하시겠습니까?`, '', {
        timeout: 10000,
        showProgressBar: true,
        closeOnClick: false,
        pauseOnHover: true,
        buttons: [
          { text: '등록',
            action: (toast) => {
              this.$snotify.remove(toast.id)
              this.regCoilPrice()
            }
          },
          { text: '취소',
            action: (toast) => {
              this.$snotify.remove(toast.id)
              this.$Q('#batch-detail-input').val('')
            }
          }
        ]
      })
    },
    regCoilPrice () {
      this.$_sp.runInsertOrUpdayeSqlProc('스크랩코일가격', ['적용일자', '재질'], ['메세지'], this.coilBatchPriceInfoList)
        .then((data) => {
          this.$snotify.info('등록 되었습니다.')
          this.updateAllPriceLastDate(this.coilPriceDate)
          this.popupCoilPriceFromExcel = false
        })
        .catch(error => {
          this.isLoading = false
          if (error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error('이미 등록된 재질/가격이 있습니다.')
          } else {
            this.$snotify.error('이미 등록된 재질/가격이 있습니다.')
          }
        })
    },
    async onReadCoilPrice ($event) {
      this.coilBatchPriceInfoList = []
      // await this.$_sp.runNoEncodeFindProc('spFindAllCoilPriceHistoryGroupBy', {})
      //   .then((data) => {
      //     this.coilPriceInfoList = this.$_sp.MakeModel(data)
      //     console.log(this.coilPriceInfoList)
      //   })
      //   .catch(error => {
      //     this.isLoading = false
      //     if (error.response.status === ConstDef.GENERRAL_ERROR) {
      //       this.$snotify.error(error.response.data.message)
      //     } else {
      //       this.$snotify.error(`에러코드 : ${error.response.status}`)
      //     }
      //   })
      // if (this.coilPriceInfoList.length === 0) {
      //   await this.$_sp.runNoEncodeFindSqlProc('코일재질맵핑', null)
      //     .then((data) => {
      //       this.coilPriceInfoList = this.$_sp.MakeModel(data)
      //     })
      // }
      let file = document.getElementById('batch-detail-input')['files'][0]
      this.$Q('#batch-detail-input').val('')
      let reader = new FileReader()
      let vm = this
      reader.onloadend = function (event) {
        // excel row cell array = 1 base
        let arrayBuffer = reader.result
        const workbook = new ExcelJS.Workbook()
        workbook.xlsx.load(arrayBuffer).then(function (workbook) {
          let worksheet = workbook.worksheets[0]
          if (worksheet === null || worksheet === undefined) {
            this.$snotify.error('엑셀파일의 Sheet가 없습니다.')
          } else {
            let row = null
            for (let i = 4; ; i++) {
              row = worksheet.getRow(i)
              if (AppLib.getCellFromExcel(row, 1) === null || AppLib.getCellFromExcel(row, 1).length === 0) {
                break
              }
              // const hkmc = `${AppLib.getCellFromExcel(row, 4)}${AppLib.getCellFromExcel(row, 5)}(${AppLib.getCellFromExcel(row, 6)})`
              // const auto = vm.$_.findWhere(vm.coilPriceInfoList, { 재질: `${AppLib.getCellFromExcel(row, 1)}` })
              // if (auto === undefined) {
              //   console.log('재질미등록', `${AppLib.getCellFromExcel(row, 1)}`)
              // }
              let param = {
                적용일자: vm.coilPriceDate,
                재질: `${AppLib.getCellFromExcel(row, 1)}`,
                // 메세지: auto === undefined ? '미등록' : '',
                가격: parseInt(AppLib.getCellFromExcel(row, 3))
              }
              vm.coilBatchPriceInfoList.push(param)
            }
          }
        })
      }
      reader.readAsArrayBuffer(file)
    },
    refreshPressPurchasePrice (goodsNo) {
      this.$_sp.runUpdateProc('spRefreshPressPurchasePriceGtToday', [{ 품번: goodsNo }])
        .then((data) => {
        })
    },
    updateAllPriceLastDate (date) {
      this.$_sp.runUpdateProc('spUpdateAllPriceLastDate', [{ null: '' }])
        .then((data) => {
          // date 보다 크거나같은 일자에 대해 외주품가격 삭제후 인서트
          this.$_sp.runUpdateProc('spUpdatePressPurchasePrice', [{ 적용일자: date }])
            .then((data) => {
              this.refreshScrapCostType()
            })
        })
    },
    onEditorPreparingPriceDate (e) {
      if (e.dataField === '가격' && e.row !== undefined) {
        if (e.row.isNewRow === true) {
          this.isEditDate = true
        } else {
          this.isEditDate = false
        }
        console.log(this.isEditDate)
      }
    },
    // *********** popup coil price batch
    checkRegDate (date) {
      if (date.substring(8, 10) !== '01') {
        this.$snotify.info('적용일자는 매월 1일만 가능합니다.')
        date = `${date.substring(0, 7)}-01`
        console.log(date)
      }
      if (this.lastCoilPriceRegDate === null) {
        this.coilPriceDate = date
      } else {
        // let temp = `${AppLib.calcMonthFromToday(0).substring(0, 7)}-01`
        let last = AppLib.formatDateFromTimeStamp(this.lastCoilPriceRegDate)
        console.log(last)
        if (last > date) {
          const lastDay = AppLib.getMonthLastDay(last.substring(0, 4), last.substring(5, 7))
          this.coilPriceDate = AppLib.calcDateFromFormat(`${last.substring(0, 7)}-${lastDay}`, 1)
          this.$snotify.info(`적용일은 ${last} 보다 커야 합니다.`)
        } else {
          this.coilPriceDate = date
        }
      }
      if (this.coilRegDateBox !== null) {
        this.coilRegDateBox.option({ value: this.coilPriceDate })
      }
    },
    onToolbarPreparingBatch (e) {
      e.toolbarOptions.items.unshift(
        {
          location: 'before',
          template: function () {
            return `<div class="toolbar-label" style='margin-left:4px;'><b>최종적용일:</b></div>`
          }
        },
        {
          location: 'before',
          widget: 'dxDateBox',
          options: {
            width: 94,
            value: this.coilPriceDate,
            type: 'date',
            displayFormat: 'yyyy-MM-dd',
            onInitialized: (args) => {
              this.coilRegDateBox = args.component
            },
            onValueChanged: (args) => {
              console.log(args)
              this.checkRegDate(args.value)
              if (this.coilBatchPriceInfoList.length > 0) {
                this.$snotify.warning('가격정보 엑셀파일 Load후 적용일자 변경은 유효하지 않습니다. 파일을 다시 로드하여 주세요.')
              }
            }
          }
        },
        {
          location: 'after',
          widget: 'dxButton',
          options: {
            hint: 'HKMC파일선택',
            icon: 'xlsfile',
            text: 'HKMC파일선택',
            type: 'default',
            focusStateEnabled: true,
            onClick: (args) => {
              this.onClickFileSelect()
            }
          }
        },
        {
          location: 'after',
          widget: 'dxButton',
          options: {
            hint: '원자재(코일) 변동 가격 등록',
            icon: 'add',
            text: '원자재(코일)가 일괄등록',
            type: 'success',
            focusStateEnabled: true,
            onClick: (args) => {
              if (this.coilBatchPriceInfoList.length === 0) {
                this.$snotify.info('HKMC 파일 선택후 등록하여 주세요.')
                return
              }
              this.confirmRegColiPrice()
            }
          }
        }
      )
    }
  }
}
</script>

<style lang="scss">

</style>
